<template>
  <v-app>
    <the-header/>
    <v-main transition="slide-x-transition">
      <router-view @refresh-chat-state="refreshChatState" @set-livechat-session-data="setSessionData"/>
    </v-main>
    <the-footer/>
    <LiveChatWidget
        :key="liveWidget"
        :license="CONFIG.LIVE_CHAT_LICENCE"
        :customer-name="name"
        :customer-email="email"
        :session-variables="sessionData"
        :visibility="visibility"
        :custom-identity-provider="provideCustomIdentity"
    />
  </v-app>
</template>

<script>
import { LiveChatWidget } from '@livechat/widget-vue'
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import {CONFIG} from "@/common/config";
import {auth} from "@/common/auth";
import {api} from "@/common/api";

export default {
  name: 'App',
  components: {LiveChatWidget, TheFooter, TheHeader},
  computed: {
    CONFIG() {
      return CONFIG
    }
  },
  data() {
    return {
      liveWidget: 1,
      name: null,
      email: null,
      sessionData: null,
      visibility: 'minimized'
    }
  },
  mounted() {
    if (auth.isAuthorized()) {
      this.getProfile()
    }
  },
  methods: {
    refreshChatState() {
      this.sessionData = null
      this.liveWidget += 1
    },
    setSessionData(data) {
      this.sessionData = data
      this.visibility = 'maximized'
      this.liveWidget += 1
    },
    async getProfile() {
      const token = auth.getToken()
      if (token == null) {
        return
      }

      let response = await api.getProfile(token)
      if (response?.data?.status === 'error') {
        return
      }

      this.setProfileFromResponse(response.data);
    },
    setProfileFromResponse(data) {
      if (data.first_name !== undefined && data.last_name !== undefined) {
        this.name = data.first_name + ' ' + data.last_name
      } else {
        this.name = auth.getUsername()
      }
      this.email = auth.getUsername()
    },
    provideCustomIdentity() {
      let token = auth.getToken()
      const getToken = async () => {
        const data = await api.getChatToken(token)
        return {
          accessToken: data.data.token,
          entityId: data.data.id,
          expiresIn: 14400000,
          tokenType: 'Bearer',
          creationDate: Date.now(),
          licenseId: CONFIG.LIVE_CHAT_LICENCE
        }
      }

      const getFreshToken = async () => {
        const data = await api.createChatToken(token)

        return {
          accessToken: data.data.token,
          entityId: data.data.id,
          expiresIn: 14400000,
          tokenType: 'Bearer',
          creationDate: Date.now(),
          licenseId: CONFIG.LIVE_CHAT_LICENCE
        }
      }

      const hasToken = async () => {
        const response = await api.getChatToken(token)
        const chatToken = await response.data
        return chatToken.token !== null
      }

      const invalidate = async () => {
        await api.deleteChatToken(token)
        return true
      }

      return {
        getToken,
        getFreshToken,
        hasToken,
        invalidate,
      }
    }
  }
}
</script>
